<script>
import { BCardHeader } from "bootstrap-vue";

export default {
  extends: BCardHeader
};
</script>